import React, { useState, useEffect } from 'react';
import { Card, CreateFinancialYearForm } from '../components';
import api from '../services/api';
import '../styles/AddUser.scss';

const FinancialYearSelect = () => {
  const [companies, setCompanies] = useState([]);
  const [created, setCreated] = useState(null);

  useEffect(() => {
    api.get('/core/companies/')
      .then(res => setCompanies(res.data.filter(c => !c.archived)))
      .catch(() => {});
  }, []);

  return (
    <div className="add-user-container">
      <Card title="Create Financial Year" className="add-user-card">
        {created && (
          <div className="success-banner">
            Financial year <strong>{created.label}</strong> created successfully.
          </div>
        )}
        <CreateFinancialYearForm companies={companies} onCreated={setCreated} />
      </Card>
    </div>
  );
};

export default FinancialYearSelect;
